import { css, SerializedStyles } from '@emotion/react';
import { mediaQueries, pxToRem } from '@upsun/react-component-library/src/styles/css-utils';
import React, { ReactNode } from 'react';

type PricingTableProps = {
  children: ReactNode
  css?: SerializedStyles | SerializedStyles[]
};

const PricingTable:React.FC<PricingTableProps> = ({ children, ...props }) => {
  const tableStyles = css`
    border: ${pxToRem(1)} solid #646F75;
    border-radius: ${pxToRem(12)};
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    margin-bottom: ${pxToRem(16)};

    ul, li {
      font-size: inherit;
    }

    tr {
      display: flex;
      flex-direction: column;
      padding: ${pxToRem(8)};
    }

    tr:not(:first-of-type){
      border-top: ${pxToRem(1)} solid #646F75;
    }

    td svg {
      position: relative;
      top: ${pxToRem(4)};
    }

    ${mediaQueries.md} {
      margin-bottom: ${pxToRem(32)};

      tr {
        display: table-row;
      }

      td {
        border-bottom: none;
        padding: ${pxToRem(16)};
      }

      tr:not(:first-of-type) td {
        border-top: ${pxToRem(1)} solid #646F75;
      }
      
      td:not(:last-of-type) {
        border-right: ${pxToRem(1)} solid #646F75;
      }
    }
  `;

  return (
    <table css={tableStyles} {...props}>{children}</table>
  );
};

export default PricingTable;
